import { render, staticRenderFns } from "./FileUploadListLite.vue?vue&type=template&id=70678e6d&scoped=true&"
import script from "./FileUploadListLite.vue?vue&type=script&lang=js&"
export * from "./FileUploadListLite.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadListLite.vue?vue&type=style&index=0&id=70678e6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70678e6d",
  null
  
)

export default component.exports